'use client';

import React, { useCallback, useEffect, useState } from 'react';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import classNames from 'classnames';

import useEmblaCarousel from 'embla-carousel-react';
import { containerWidthOptions } from '../../editor/Toolbar/options';

export const getSlideClass = (cols) => {
	switch (cols) {
	case '2':
		return 'embla__2col';
	case '3':
		return 'embla__3col';
	case '4':
		return 'embla__4col';
	case '5':
		return 'embla__5col';
	case '6':
		return 'embla__6col';
	case '1':
	default:
		return 'embla__1col';
	}
};

export function DotButton({ selected, onClick }) {
	return (
		<button
			onClick={onClick}
			className={classNames('rounded-full w-2 h-2 mr-2', selected ? 'bg-blue-700' : 'bg-gray-300')}
		/>
	);
}

export default function Carousel({ children, maxWidth, cols }) {
	// const options = { ...defaultOptions, items: cols };

	const [slides, setSlides] = useState([]);
	const [emblaRef, embla] = useEmblaCarousel();
	const [selectedIndex, setSelectedIndex] = useState(0);

	const onSelect = useCallback(() => {
		if (!embla) return;
		setSelectedIndex(embla.selectedScrollSnap());
	}, [embla, setSelectedIndex]);

	useEffect(() => {
		if (!embla) return;
		onSelect();
		setSlides(embla.scrollSnapList());
		embla.on('select', onSelect);
	}, [embla, setSlides, onSelect, children, cols]);

	const scrollTo = useCallback((index) => embla && embla.scrollTo(index), [embla]);

	return (
		<div
			className={classNames('text-center w-full overflow-hidden @sm:mx-auto')}
			style={{ maxWidth: containerWidthOptions[maxWidth] }}
		>
			<div className="embla" ref={emblaRef}>
				<ul className={classNames('embla__container', getSlideClass(cols))}>
					{children}
				</ul>
				{slides.map((_, index) => (
					<DotButton
						key={index}
						selected={index === selectedIndex}
						onClick={() => scrollTo(index)}
					/>
				))}
			</div>
		</div>
	);
}
